import { Component, computed, input } from '@angular/core'
import { numberDisplay } from 'src/app/shared/services/filter/number-range-filter'

@Component({
  selector: '[app-number-display]',
  template: '{{ display() }}',
  styles: `
        :host {
            position: relative;
            display: block;
            margin-top: 0.5rem;
        }
    `,
})
export class NumberDisplayComponent {
  value = input<number | null>()
  precision = input<number>(8)

  display = computed(() => {
    return numberDisplay(this.value() ?? NaN, this.precision())
  })
}